export default __webpack_public_path__ + "static/media/537.c5b4d72a.png";